import React, {ReactElement, ReactNode} from 'react';

import './ContentCard.scss';

export enum CopyAlign {
  LEFT = 'copyLeft',
  CENTER = 'copyCenter',
}

interface ContentCardProps {
  children: ReactNode;
  className?: string;
  imgUrl?: string;
  imgComponent?: ReactNode;
  innerClassName?: string;
}

function ContentCard({children, className, imgUrl, imgComponent, innerClassName}: ContentCardProps): ReactElement {
  return (
    <div className={`contentCard ${className || ''}`.trim()} data-testid="ui.contentCard">
      <div className={`contentCard__inner ${innerClassName || ''}`}>
        {imgUrl && (
          <div
            className="contentCard__imageWrapper"
            style={{
              backgroundImage: `url(${imgUrl})`,
            }}
          />
        )}
        {imgComponent && <div className="contentCard__imageWrapper">{imgComponent}</div>}
        {children}
      </div>
    </div>
  );
}

export default ContentCard;
